package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.title
import dev.danko.roblox_craft_ai.uikit.i18n.AppLocale
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import org.jetbrains.compose.web.css.cssRem

@Composable
fun LanguageSwitcher(modifier: Modifier = Modifier) {
    val current = LocaleController.current
    Row(
        modifier = modifier.gap(0.25.cssRem).title(strings().common.language),
        verticalAlignment = Alignment.CenterVertically
    ) {
        AppLocale.entries.forEach { locale ->
            AppButton(
                text = locale.shortLabel,
                variant = if (locale == current) AppButtonVariant.PRIMARY else AppButtonVariant.OUTLINE,
                size = AppButtonSize.SM,
                onClick = { LocaleController.select(locale) },
                modifier = Modifier.title(locale.nativeName)
            )
        }
    }
}
